import PropTypes from 'prop-types';
import React from 'react';

import Select from 'containers/Select';

// eslint-disable-next-line import/no-default-export
export default class WidgetMultiselect extends React.Component {
  state = {
    options: [],
  };

  UNSAFE_componentWillMount() {
    // @ts-expect-error
    const enumItems = this.props.schema?.items?.enum;
    if (enumItems) {
      this.setState({
        options: enumItems.map((enumItem) => ({
          value: enumItem,
          label: enumItem,
        })),
      });
    }
  }

  onChange = (preValue) => {
    // @ts-expect-error
    const { onChange } = this.props;

    const value = Array.isArray(preValue) ? preValue : [];
    this.setState({
      value,
    });
    const nextValue = value.map((item) => item.value);

    onChange(nextValue);
  };

  render() {
    // @ts-expect-error
    const { formData, value } = this.props;
    const { options } = this.state;

    return (
      <Select
        multi
        clearable
        valueKey="value"
        value={formData || value}
        options={options}
        closeOnSelect={false}
        onChange={this.onChange}
      />
    );
  }
}

// @ts-expect-error
WidgetMultiselect.propTypes = {
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};
